export default __webpack_public_path__ + "92d775ced396cfa3663e8eae7513d301.ttf";